import { ReactNode } from "react";

export const TyTimelineItemButton = ({
  onClickHandler,
  children,
}: {
  onClickHandler: () => void;
  children: ReactNode;
}) => {
  return (
    <button
      className="bg-primary-200 hover:bg-primary-300 text-[11px] text-primary-800 font-geist font-semibold py-2 px-4 rounded-full w-fit items-center gap-2"
      onClick={onClickHandler}
    >
      <span>{children}</span>
    </button>
  );
};
